import React, { Component } from 'react';
import translate from 'react-i18next/dist/commonjs/translate';

// Styles & Images
import ClearImg from 'assets/images/invoice/clear.svg';
import MinusImg from 'assets/images/invoice/reduce.svg';
import PlusImg from 'assets/images/invoice/add.svg';
import styles from './styles';

class InputCertificateNumber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      certificateNumber: props.maxCertificateNumber || '',
      disableMinus: !props.maxCertificateNumber
    };
    this.cleanCertificateNumber = this.cleanCertificateNumber.bind(this);
    this.onHandleInput = this.onHandleInput.bind(this);
    this.sendNewCertificateValue = this.sendNewCertificateValue.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { maxCertificateNumber } = this.props;
    if (maxCertificateNumber !== prevProps.maxCertificateNumber) {
      this.setState({
        certificateNumber: maxCertificateNumber || '',
        disableMinus: !maxCertificateNumber
      });
    }
  }

  onChangeCounter(isPlus) {
    const certificateNumber = Number(this.state.certificateNumber);
    let value;
    if (isPlus) {
      value = certificateNumber + 1;
    } else {
      value = certificateNumber && certificateNumber > 1 ? certificateNumber - 1 : '';
    }
    this.setState({ certificateNumber: value, disableMinus: !value }, () => {
      this.sendNewCertificateValue(value);
    });
  }

  cleanCertificateNumber() {
    const value = '';
    this.setState({ certificateNumber: value, disableMinus: true }, () => {
      this.sendNewCertificateValue(value);
    });
  }

  onHandleInput(e) {
    const value = e.target.value;
    this.setState(
      {
        certificateNumber: value,
        disableMinus: false
      },
      () => {
        this.sendNewCertificateValue(value);
      }
    );
  }

  sendNewCertificateValue(value) {
    const { onChangeCertificate } = this.props;
    onChangeCertificate && onChangeCertificate(value);
  }

  render() {
    const { i18n, error } = this.props;
    const { certificateNumber, disableMinus } = this.state;

    return (
      <styles.ICN_Wrapper>
        <styles.ICN_InputWrapper error={error}>
          <input
            placeholder={i18n.t('certificate_number')}
            value={certificateNumber}
            onChange={this.onHandleInput}
            placeholder={i18n.t('certificate_number')}
            type="number"
          />

          {certificateNumber ? <img src={ClearImg} onClick={this.cleanCertificateNumber} alt="clear"/> : null}
        </styles.ICN_InputWrapper>

        <styles.ICN_CounterWrapper>
          <img
            alt="minus"
            className={disableMinus ? 'disabled' : ''}
            src={MinusImg}
            onClick={() => {
              !disableMinus && this.onChangeCounter();
            }}
          />

          <img src={PlusImg} onClick={() => this.onChangeCounter(true)} alt="plus"/>
        </styles.ICN_CounterWrapper>
      </styles.ICN_Wrapper>
    );
  }
}

export default translate()(InputCertificateNumber);
